import { Container, Card } from "react-bootstrap";

export default function MaintenanceMode() {
  return (
    <Container className="mt-5 px-3 px-md-4">
      <Card className="brutal-card">
        <Card.Body className="p-5 text-center">
          <div style={{ fontSize: "72px", marginBottom: "20px" }}>🔧</div>
          <Card.Title className="brutal-heading mb-4" style={{ fontSize: "48px" }}>
            MAINTENANCE MODE
          </Card.Title>
          <p className="brutal-text" style={{ fontSize: "20px", marginBottom: "30px" }}>
            WE'RE CURRENTLY PERFORMING MAINTENANCE ON THE SITE.
          </p>
          <p className="brutal-text" style={{ fontSize: "16px", color: "#666" }}>
            PLEASE CHECK BACK SOON. WE'LL BE BACK UP SHORTLY.
          </p>
          <div style={{ marginTop: "40px", padding: "20px", border: "4px solid #000000", backgroundColor: "#FFFF00" }}>
            <p style={{ margin: 0, fontWeight: "900", fontSize: "14px" }}>
              THANK YOU FOR YOUR PATIENCE.
            </p>
          </div>
        </Card.Body>
      </Card>
      <style>{`
        .brutal-card {
          background: #FFFFFF;
          border: 6px solid #000000;
          box-shadow: 12px 12px 0px #000000;
        }
        .brutal-heading {
          font-family: 'Courier New', monospace;
          font-weight: 900;
          color: #000000;
          text-transform: uppercase;
          letter-spacing: 2px;
        }
        .brutal-text {
          font-family: 'Courier New', monospace;
          font-weight: 700;
          color: #000000;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
      `}</style>
    </Container>
  );
}
